import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

import AscSortButtonPath from '../../image/AscSortButton.png';
import DescSortButtonPath from '../../image/DescSortButton.png';

export default function ZoneSubscribeColumn() {
  const { t } = useLanguage();

  const [startButtonImg, setStartButtonImg] = useState(AscSortButtonPath);
  const [startDateSort, setStartDateSort] = useState(true);

  useEffect(() => {
    if (startDateSort) setStartButtonImg(AscSortButtonPath);
    else setStartButtonImg(DescSortButtonPath)
  }, [startDateSort])

  return (
    <TopLevelWrapper>
      <Column style={{ marginLeft: '28px' }} width={116}>
        <SortingWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.approvalDate')}</Text>
          <SortingButton img={startButtonImg} onClick={() => setStartDateSort(!startDateSort)} style={{ marginRight: '49px' }} />
        </SortingWrapper>
      </Column>
      <Column width={96}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.payerName')}</Text>
      </Column>
      <Column width={72}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.paymentType')}</Text>
      </Column>
      <Column width={466}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.paymentDetails')}</Text>
      </Column>
      <Column width={96}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.paymentAmount')}</Text>
      </Column>
      <Column width={100}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.remainingPeriod')}</Text>
      </Column>
      <Column width={90}>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>{t('myStoreSetting.subscribe.approvalStatus')}</Text>
      </Column>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  gap: 12px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const SortingWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const SortingButton = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  background: url(${props => props.img}) no-repeat center center;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
